.root {
    color: white;
    align-items: center;
}

.title {
    font-weight: 700;
    color: white;
}

.icon {
    background-color: transparent;
}

.description {
    color: white;
    font-size: var(--mantine-font-size-sm);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 10;
    line-clamp: 10;
    -webkit-box-orient: vertical;
}

.closeButton {
    color: white;

    &:hover {
        background-color: transparent;
        color: white;
    }
}
